var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 0.5C6.69159 0.5 3.33325 3.85833 3.33325 8H0.833252L4.07492 11.2417L4.13325 11.3583L7.49992 8H4.99992C4.99992 4.775 7.60825 2.16667 10.8333 2.16667C14.0583 2.16667 16.6666 4.775 16.6666 8C16.6666 11.225 14.0583 13.8333 10.8333 13.8333C9.22492 13.8333 7.76659 13.175 6.71659 12.1167L5.53325 13.3C6.89159 14.6583 8.75825 15.5 10.8333 15.5C14.9749 15.5 18.3333 12.1417 18.3333 8C18.3333 3.85833 14.9749 0.5 10.8333 0.5ZM9.99992 4.66667V8.83333L13.5666 10.95L14.1666 9.94167L11.2499 8.20833V4.66667H9.99992Z",
    fill: "#697474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.a28ad239bf442fcff9f43008cf179290.svg";
export { ForwardRef as ReactComponent };